import { PAGINATION_DEFAULTS } from "@root/constants";
import get from "lodash.get";
import { createSelector } from "reselect";

const appFeatureSelector = (state: TReduxState) => state.root.features.chat;

export const getChatFeatureData = createSelector(appFeatureSelector, (orders) =>
  get(orders, "data", null)
);

export const getPage = createSelector(getChatFeatureData, (app) =>
  get(app, "page", 1)
);

export const getPageSize = createSelector(getChatFeatureData, (app) =>
  get(app, "pageSize", PAGINATION_DEFAULTS.PAGESIZE)
);

export const getPageCount = createSelector(getChatFeatureData, (app) =>
  get(app, "pageCount", 0)
);

export const selectListThreads = createSelector(appFeatureSelector, (app) =>
  get(app, "listThreads", [])
);
